<ng-container *ngIf="simpleView && showMapOnMobile">
  <input
    autofocus
    id="locationSearch"
    class="text-input w-input"
    [formControl]="searchField"
    [ngbTypeahead]="searchPoi"
    [focusFirst]="true"
    [resultFormatter]="poiFormatter"
    [inputFormatter]="poiFormatter"
    (selectItem)="locationSelected($event, 'coordinates-map-modal')"
    placeholder="{{ searchField.value || 'Type your address here...' }}"
    type="text"
    name="address-lookup"
  />
  <p class="fine-print clickable" (click)="toggleSimpleView()">
    <em> The address isn&rsquo;t showing up, or property doesn't have an address </em>
  </p>
  <div class="_18-px-spacer"></div>
  <p class="fine-print">
    Entering an address here will help us find your coordinates. Ultimately, the GPS coordinates are what CurbNTurfers
    will need.
  </p>
</ng-container>

<ng-container *ngIf="!simpleView || !showMapOnMobile">
  <div class="custom-address">
    <h4>Custom Physical Address</h4>
    <button type="button" (click)="toggleSimpleView()" class="cnt-button back-to-simple" *ngIf="showMapOnMobile">
      <div class="cnt-button-copy">Back to address lookup</div>
    </button>
  </div>
  <div *ngIf="addressForm" [formGroup]="addressForm">
    <label for="address">Address</label>
    <input id="address" type="text" formControlName="address" class="text-input w-input" name="address" />
    <label for="city">City</label>
    <input id="city" type="text" formControlName="city" class="text-input w-input" name="city" />
    <label for="state">State</label>
    <input id="state" type="text" formControlName="state" class="text-input w-input" name="state" />
    <label for="zipcode">ZIP Code</label>
    <input id="zipcode" type="text" formControlName="zipcode" class="text-input w-input" name="zipcode" />
  </div>
</ng-container>
<ng-container *ngIf="coordinatesForm && (!simpleView || coordinatesShow)" [formGroup]="coordinatesForm">
  <div class="_12-px-spacer"></div>
  <div class="horz-line"></div>
  <div class="_18-px-spacer"></div>
  <h4>Pin your site (GPS Coordinates)</h4>
  <p>
    We recommend verifying your coordinates by standing at the site location and tap &ldquo;use my current
    location&rdquo; or &ldquo;find on map&rdquo;.
  </p>
  <div class="_12-px-spacer"></div>
  <div class="button-wrapper-grid">
    <button type="button" class="cnt-button" (click)="setCoordinatesToCurrent()">
      <div class="cnt-button-copy">Use My Current Location</div>
    </button>
    <button
      type="button"
      class="cnt-button"
      (click)="getCoordinatesFromMap()"
      *ngIf="coordinatesForm.value.lat && coordinatesForm.value.lon"
    >
      <div class="cnt-button-copy">Find On Map</div>
    </button>
    <button
      type="button"
      class="cnt-button"
      (click)="setCoordinatesFromAddress('coordinates-map-modal')"
      *ngIf="!coordinatesForm.value.lat || !coordinatesForm.value.lon"
    >
      <div class="cnt-button-copy">Find On Map</div>
    </button>

    <div class="left-column-wrapper">
      <div class="title-2up">Latitude</div>
      <input
        type="number"
        min="-90"
        max="90"
        step="0.000001"
        formControlName="lat"
        class="l-lat-text-field text-input w-input"
        name="latitude"
      />
      <p *ngIf="latitudeError" class="alert-danger">
        <i class="icon-cnt-times-circle"></i>
        {{ latitudeError }}
      </p>
    </div>
    <div class="right-column-wrapper">
      <div class="title-2up">Longitude</div>
      <input
        id="lon"
        type="number"
        min="-180"
        max="180"
        step="0.000001"
        formControlName="lon"
        class="l-lat-text-field text-input w-input"
        name="longitude"
      />
      <p *ngIf="longitudeError" class="alert-danger">
        <i class="icon-cnt-times-circle"></i>
        {{ longitudeError }}
      </p>
    </div>
  </div>
</ng-container>
